module.exports = __webpack_public_path__ + "img/cup-grey.28674183.png";